import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  onMounted,
  onBeforeUnmount,
  ref,
  watch,
  nextTick,
} from "vue";
import * as echarts from "echarts/core";
import {
  PieChart,
  LineChart,
  BarChart,
  ScatterChart,
  GraphChart,
} from "echarts/charts";
import {
  TooltipComponent,
  LegendComponent,
  GridComponent,
  TitleComponent,
  GraphicComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import type { EChartsOption } from "echarts";


export default /*@__PURE__*/_defineComponent({
  __name: 'Chart',
  props: {
    option: {}
  },
  emits: ["resize", "chartReady"],
  setup(__props: any, { emit: __emit }) {

echarts.use([
  PieChart,
  LineChart,
  BarChart,
  GraphChart,
  ScatterChart,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  TitleComponent,
  CanvasRenderer,
  GraphicComponent,
]);

// props
const props = __props;

// emit
const emit = __emit;

const chartContainer = ref<HTMLDivElement | null>(null);
let chart: echarts.ECharts | null = null;
let resizeObserver: ResizeObserver | null = null;

// chartを初期化する
const initChart = () => {
  if (!chartContainer.value) return;
  if (chart) {
    try {
      chart.dispose();
    } catch (e) {
      // dispose が失敗しても続行
    }
    chart = null;
  }

  chart = echarts.init(chartContainer.value);
  // 設定を更新
  chart.setOption(props.option, true);

  // ResizeObserverが利用可能なら使う
  if (typeof ResizeObserver !== "undefined") {
    resizeObserver?.disconnect();
    resizeObserver = new ResizeObserver(() => {
      // 幅を親へ通知
      emit("resize", chartContainer.value!.clientWidth);
      chart?.resize();
    });
    resizeObserver.observe(chartContainer.value);
  } else {
    // リサイズ
    window.addEventListener("resize", chartResize);
  }
  emit("chartReady", chart);
};

const chartResize = () => {
  try {
    chart?.resize();
  } catch (e) {
    // resize中にエラーが出ても無視
  }
};

onMounted(() => {
  // DOMが描画された後に初期化
  nextTick(initChart);
});

onBeforeUnmount(() => {
  try {
    chart?.dispose();
  } catch (e) {
    // disposeが失敗しても続行
  }
  chart = null;
  if (typeof ResizeObserver !== "undefined") {
    resizeObserver?.disconnect();
    resizeObserver = null;
  } else {
    window.removeEventListener("resize", chartResize);
  }
});

// props.optionが変化したら反映
watch(
  () => props.option,
  () => {
    initChart();
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "chartContainer",
    ref: chartContainer,
    class: _normalizeClass(["chart-container", _ctx.$attrs.class])
  }, null, 2))
}
}

})